<template>
  <v-simple-table>
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-right">ID</th>
          <th class="text-right">Flags</th>
          <th class="text-right">ReceivedOn</th>
          <th class="text-right">RD Start</th>
          <th class="text-right">RD Read</th>
          <th class="text-right">RD End</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="value != null">
          <td>{{ value.id }}</td>
          <td><HeartbeatFlags :heartbeat="value" /></td>
          <td>
            {{ value.receivedOn | moment('DD/MMM/YYYY HH:mm:ss') }}
          </td>
          <td>{{ value.originalLastPointer | brNum }}</td>
          <td>{{ value.summary.rawDataLength | brNum }}</td>
          <td>{{ value.summary.endPointer | brNum }}</td>
        </tr>
        <tr v-else>
          <td colspan="6">─</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
import HeartbeatFlags from '../../components/heartbeats/flags/HeartbeatFlags.vue'

export default {
  components: { HeartbeatFlags },
  props: {
    value: {}
  }
}
</script>

<style></style>
